mutation ApprovalTestResultAttach($input: ApprovalTestResultAttachInput!) {
  approvalTestResultAttach(input: $input) {
    integer
    clientMutationId
  }
}
